// extracted by mini-css-extract-plugin
module.exports = {"container":"policy_container__BGX8z","footer":"policy_footer__53Fhw","backBtn":"policy_backBtn__RRjLX","nextBtn":"policy_nextBtn__E4rfa"};